import { Navigate } from "react-router-dom";
import SideBar from "../../Components/Utilities/SideBar";
import AccountantWithDrwasComponent from "../../Components/withDraws/AccountantWithDrwasComponent";

export default function AccountantWithDrawPage() {
    const loggedUser = JSON.parse(localStorage.getItem('user'));
    if(!loggedUser) return  <Navigate to='/' />

    return (
        <div className="d-flex justify-content-start">
            <div>
                <SideBar />
            </div>
            <div className="p-3 w-100 dashboard">
                <AccountantWithDrwasComponent />
            </div>
        </div>
    )
}
